<template>
  <div class="cart__item product">
    <div class="product__pic">
      <img :src="item.color.gallery[0].file.url" width="120" height="120" :alt="item.product.title">
    </div>
    <h3 class="product__title">
      {{ item.product.title }}
    </h3>
    <p class="product__info product__info--color">
      Цвет:
      <span>
        <i :style="{ backgroundColor: item.color.color.code }"></i>
        {{ item.color.color.title }}
      </span>
      Размер:
      <span>{{ item.size.title }}</span>
    </p>
    <span class="product__code">
      Артикул: {{ item.product.id }}
    </span>

    <BaseAmount v-model.number="amount" />

    <b class="product__price">
      {{ (item.amount * item.product.price) | numberFormat }} ₽
    </b>

    <button class="product__del button-del" type="button" aria-label="Удалить товар из корзины"
      @click.prevent="deleteProductToCart(item.id)">
      <svg width="20" height="20" fill="currentColor">
        <use xlink:href="#icon-close"></use>
      </svg>
    </button>
  </div>
</template>

<script>
import BaseAmount from "@/components/BaseAmount.vue";
import numberFormat from '@/helpers/numberFormat';
import { mapActions } from 'vuex';

export default {
  components: { BaseAmount },
  filters: { numberFormat },
  props: ['item'],
  computed: {
    amount: {
      get() {
        return this.item.amount
      },
      set(value) {
        this.$store.dispatch('updateCartProductAmount', { id: this.item.id, amount: value });
      }
    },
  },
  methods: {
    ...mapActions(['deleteProductToCart']),
  }
}
</script>
<style>
.product__info span {
  margin-right: 12px;
}

.product__info span:last-child {
  padding-left: 3px;
}
</style>
